import {useCallback, useEffect, useState} from 'react'

import ContractsService from '@/services/api/Contracts'
import {isNotMarketMaker} from '@/components/Store/MarketMaker/constants'

const useIsMarketMaker = (enabled: boolean) => {
  const [isMarketMaker, setIsMarketMaker] = useState(false)
  const [isChecked, setIsChecked] = useState(false)

  const check = useCallback(async () => {
    try {
      const res = await ContractsService.getContracts()
      const data: any = res.data
      setIsMarketMaker(!isNotMarketMaker(data?.local_code))
    } catch (e: any) {
      setIsMarketMaker(false)
    } finally {
      setIsChecked(true)
    }
  }, [])

  useEffect(() => {
    if (!enabled) {
      setIsMarketMaker(false)
      setIsChecked(false)
      return
    }
    void check()
  }, [enabled, check])

  return {isMarketMaker, isChecked}
}

export default useIsMarketMaker
